import requests from "./httpService";

const HolidayService = {
     getAllHoliday: async () =>{
        return requests.get("/holiday/all");
     },
     getHolidayById: async (id, body) =>{
        return requests.get(`/holiday/${id}`, body);
     },
     UpdateHolidayById: async (id, body) =>{
        return requests.put(`/holiday/${id}`, body);
     },
     addHoliday: async (body) =>{
        return requests.post("/holiday/add", body);
     },
     deleteHolidayById: async (id) =>{
        return requests.delete(`/holiday/${id}`);
     }
}

export default HolidayService;